
import { setVariantsVisualizationGraphType } from '@process-advisor/process-miner/api/methods/lifecycle/setVariantsVisualizationGraphType'
import { setVariantsVisualizationMetric } from '@process-advisor/process-miner/api/methods/lifecycle/setVariantsVisualizationMetric'
import { setTasksVisualizationGraphType } from '@process-advisor/process-miner/api/methods/lifecycle/setTasksVisualizationGraphType'
import { setTasksVisualizationMetric } from '@process-advisor/process-miner/api/methods/lifecycle/setTasksVisualizationMetric'
import { setTasksVisualizationFilter } from '@process-advisor/process-miner/api/methods/lifecycle/setTasksVisualizationFilter'
import { setTasksVisualizationNumTasks } from '@process-advisor/process-miner/api/methods/lifecycle/setTasksVisualizationNumTasks'
import { setTasksVisualizationSource } from '@process-advisor/process-miner/api/methods/lifecycle/setTasksVisualizationSource'
import { setTasksVisualizationSort } from '@process-advisor/process-miner/api/methods/lifecycle/setTasksVisualizationSort'

export const lifeCycleMethods = {
    setVariantsVisualizationGraphType,
    setVariantsVisualizationMetric,
    setTasksVisualizationGraphType,
    setTasksVisualizationMetric,
    setTasksVisualizationNumTasks,
    setTasksVisualizationSort,
    setTasksVisualizationFilter,
    setTasksVisualizationSource
};
